/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Scope_Point_1Inputs */

const en_svc_research_scope_point_1 = /** @type {(inputs: Svc_Research_Scope_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Market and competitor research`)
};

const lv_svc_research_scope_point_1 = /** @type {(inputs: Svc_Research_Scope_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirgus un konkurentu izpēte`)
};

/**
* | output |
* | --- |
* | "Market and competitor research" |
*
* @param {Svc_Research_Scope_Point_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_scope_point_1 = /** @type {((inputs?: Svc_Research_Scope_Point_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Scope_Point_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_scope_point_1(inputs)
	return en_svc_research_scope_point_1(inputs)
});